import "./App.css";
import Navbar from "./components/Navbar";
import { BrowserRouter,Routes,Route } from "react-router-dom";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import ProductOfCustomers from "./pages/Customers";
import ProductOfConsumers from "./pages/Consumers";
import ContactUsForm from "./pages/Contact";
import WhatsAppButton from "./components/WhatsAppButton";
import AquacultureDivision from "./pages/AquacultureDivision";


function App() {
  return(
    <BrowserRouter>
    <Navbar/>
    <WhatsAppButton/>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/customers" element={<ProductOfCustomers />} />
      <Route path="/consumers" element={<ProductOfConsumers />} />
      <Route path="/aquaculture-division" element={<AquacultureDivision />} />
      <Route path="/contact" element={<ContactUsForm />} />
    </Routes>
    <Footer/>
    </BrowserRouter>
  )
}

export default App;
